// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.seguimiento-action-link > i {
  display: none;
}

@media (max-width: 767px) {
  .modal {
    position: fixed !important;
    inset: 0 !important;
    padding: 0 !important;
    width: 100vw !important;
    max-width: 100vw !important;
    width: 100dvw !important;
    max-width: 100dvw !important;
    box-sizing: border-box !important;
    overflow-x: hidden;
  }

  .modal.show,
  .modal.fade.show {
    display: flex !important;
    align-items: flex-end;
  }

  .modal .modal-dialog {
    position: absolute !important;
    inset: auto auto 0 50% !important;
    display: flex;
    align-items: flex-end;
    /* Reactstrap can provide an inline maxWidth (for example 90%).  On a
       phone every sheet must span the complete viewport, independently of
       the modal variant that opened it. */
    width: 100vw !important;
    min-width: 0 !important;
    max-width: 100vw !important;
    width: 100dvw !important;
    max-width: 100dvw !important;
    box-sizing: border-box !important;
    flex: 0 0 100dvw;
    min-height: 0;
    height: auto;
    margin: 0 !important;
    left: 50% !important;
    right: auto !important;
    transform: translate(-50%, var(--responsive-sheet-drag-offset, 0)) !important;
    transition: transform 180ms ease;
  }

  .modal .modal-dialog > .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    max-height: min(82dvh, 760px);
    overflow: hidden;
    border: 0;
    border-radius: 22px 22px 0 0;
    box-shadow: 0 -12px 32px rgba(21, 48, 74, .18);
  }

  .modal.responsive-modal-sheet-expanded .modal-dialog > .modal-content {
    max-height: 100dvh;
    min-height: 100dvh;
    height: 100dvh;
    border-radius: 0;
  }

  .modal .modal-dialog > .modal-content > .modal-body {
    flex: 1 1 auto;
    min-height: 0;
    max-height: calc(min(82dvh, 760px) - 72px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .modal.responsive-modal-sheet-expanded .modal-dialog > .modal-content > .modal-body {
    height: auto;
    max-height: none;
    min-height: 0;
  }

  /* Base global de altura: el contenido ocupa toda la hoja y el body es el
     único elemento que desplaza. Esto evita el espacio vacío inferior que
     aparece cuando un modal conserva un max-height heredado. */
  .modal .modal-dialog > .modal-content {
    height: min(82dvh, 760px);
  }

  .modal .modal-dialog > .modal-content > .modal-body {
    height: auto;
    max-height: none !important;
  }

  .modal.responsive-modal-sheet-expanded .modal-dialog > .modal-content {
    height: 100dvh;
  }

  .responsive-modal-sheet-handle {
    display: grid;
    width: 100%;
    height: 26px;
    padding: 8px 0 6px;
    border: 0;
    background: transparent;
    cursor: grab;
    touch-action: none;
    place-items: center;
  }

  .responsive-modal-sheet-handle span {
    width: 42px;
    height: 4px;
    border-radius: 999px;
    background: #aebdcc;
  }

  .responsive-modal-sheet-handle:active {
    cursor: grabbing;
  }

  .responsive-modal-sheet-close {
    position: absolute;
    top: 30px;
    right: 12px;
    z-index: 3;
    display: grid;
    width: 36px;
    height: 36px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: #edf3f8;
    color: #38536d;
    font-size: 28px;
    line-height: 1;
    place-items: center;
  }

  /* La X solo se muestra cuando el bottom sheet está expandido. Mientras
     permanece colapsado, el cierre se hace con el gesto hacia abajo. */
  .modal:not(.responsive-modal-sheet-expanded) .modal-header .btn-close,
  .modal:not(.responsive-modal-sheet-expanded) .responsive-modal-sheet-close {
    display: none !important;
  }

  .modal.responsive-modal-sheet-expanded .modal-header .btn-close,
  .modal.responsive-modal-sheet-expanded .responsive-modal-sheet-close {
    position: absolute !important;
    top: 50px !important;
    right: 16px !important;
    z-index: 1101 !important;
    display: grid !important;
    width: 38px;
    height: 38px;
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background-color: #edf2f8;
    background-size: 14px;
    color: #30445d;
    opacity: 1;
  }

  /* Header real y sticky: el body se desplaza, pero esta capa permanece
     arriba del modal y contiene la X. */
  .modal .modal-dialog > .modal-content > .modal-header {
    position: sticky !important;
    top: 0;
    z-index: 1100;
    display: flex !important;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    height: auto;
    min-height: 26px;
    margin: 0;
    padding: 8px 0 10px !important;
    border: 0 !important;
    background: transparent;
    overflow: visible;
    pointer-events: none;
  }

  .modal .modal-dialog > .modal-content > .modal-header .modal-title {
    display: block !important;
    margin: 6px 0 0;
    padding: 8px 56px 10px 18px;
    color: #526a83;
    font-size: 18px;
    font-weight: 600;
    line-height: 1.25;
    text-align: left;
  }

  .modal .modal-dialog > .modal-content > .modal-header .base-modal-xxl-header-content {
    display: block !important;
    color: inherit;
    font: inherit;
  }

  .modal .modal-dialog > .modal-content > .modal-header .btn-close {
    position: absolute !important;
    top: 50px !important;
    right: 16px !important;
    pointer-events: auto;
  }

  .modal .modal-dialog > .modal-content > .modal-header .responsive-modal-sheet-handle {
    display: grid !important;
    flex: 0 0 26px;
    pointer-events: auto;
    position: relative;
    z-index: 1102;
  }

  /* Panel de seguimiento: composición móvil basada en el panel de ruta. */
  .modal:has(.seguimiento-modal) > .modal-dialog > .modal-content {
    background: #f7fbff;
  }

  .modal:has(.seguimiento-modal) .modal-header {
    padding: 12px 22px 8px;
    border: 0;
  }

  .modal:has(.seguimiento-modal) .modal-title,
  .modal:has(.seguimiento-modal) .base-modal-xxl-header-content {
    color: #071b49;
    font-size: clamp(25px, 7vw, 34px);
    font-weight: 800;
    line-height: 1.1;
  }

  .modal:has(.seguimiento-modal) .modal-body {
    padding: 8px 8px 24px;
  }

  .seguimiento-modal {
    padding: 0 !important;
    background: transparent !important;
  }

  .seguimiento-modal > .row {
    --mdb-gutter-x: 0;
    margin-right: 0;
    margin-left: 0;
  }

  .seguimiento-modal .seguimiento-links-row {
    margin: 0 0 14px !important;
  }

  .seguimiento-modal .seguimiento-links-row > div {
    overflow-x: auto !important;
    padding: 2px 0 8px;
    scrollbar-width: none;
  }

  .seguimiento-modal .seguimiento-links-row > div::-webkit-scrollbar {
    display: none;
  }

  .seguimiento-modal .seguimiento-links {
    width: max-content;
    gap: 9px;
  }

  .seguimiento-modal .seguimiento-action-link {
    display: inline-flex;
    align-items: center;
    min-height: 44px;
    padding: 0 15px;
    border: 1px solid #dce7f4;
    border-radius: 15px;
    background: #f3f7fc;
    color: #102554;
    font-size: 14px;
    font-weight: 700;
    text-decoration: none;
    white-space: nowrap;
  }

  .seguimiento-modal .seguimiento-action-link > i {
    display: inline-block;
    margin-right: 8px;
    font-size: 21px;
    line-height: 1;
  }

  .seguimiento-modal .seguimiento-action-link:first-child {
    border-color: #1479ff;
    background: linear-gradient(135deg, #0078ff, #1168e9);
    box-shadow: 0 8px 18px rgba(0, 103, 241, .22);
    color: #fff;
  }

  .seguimiento-modal .seguimiento-link-separator {
    display: none;
  }

  .seguimiento-modal .seguimiento-topbar {
    margin-bottom: 14px;
    padding: 14px 16px;
    border: 1px solid #e0eaf4;
    border-radius: 20px;
    background: #fff;
    box-shadow: 0 8px 22px rgba(31, 67, 110, .08);
  }

  .seguimiento-modal .seguimiento-topbar .container-fluid {
    display: block;
    padding: 0;
  }

  .seguimiento-modal .seguimiento-topbar .navbar-brand {
    display: block;
    margin: 0 0 12px;
    color: #081b49 !important;
    font-size: 21px;
    font-weight: 800;
  }

  .seguimiento-modal .seguimiento-topbar .navbar-toggler {
    display: none;
  }

  .seguimiento-modal .seguimiento-topbar .navbar-collapse,
  .seguimiento-modal .seguimiento-topbar .navbar-nav {
    display: grid !important;
    width: 100%;
    gap: 9px;
  }

  .seguimiento-modal .seguimiento-topbar .nav-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 58px;
    padding: 0 16px;
    border-radius: 14px;
    background: #edf4fb;
    color: #102b5c !important;
    font-size: 17px;
    font-weight: 600;
  }

  .seguimiento-modal .seguimiento-kpis {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
    margin: 0 0 14px;
  }

  .seguimiento-modal .seguimiento-kpis > [class*="col-"] {
    width: auto;
    max-width: none;
    padding: 0;
  }

  .seguimiento-modal .seguimiento-kpi-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    min-height: 132px;
    padding: 14px 12px;
    border: 0;
    border-radius: 17px;
    background: linear-gradient(145deg, #073c7c, #001f48);
    box-shadow: 0 8px 18px rgba(4, 38, 82, .18);
    color: #fff;
    font-family: inherit;
    font-size: 13px;
    text-align: left;
  }

  .seguimiento-modal .seguimiento-kpi-card span,
  .seguimiento-modal .seguimiento-kpi-card [id*="contenedorestado"] {
    margin-top: 6px;
    font-size: clamp(20px, 6vw, 29px);
    font-weight: 800;
    line-height: 1;
  }

  .seguimiento-modal [id*="contenedorestadodiv"] {
    background: linear-gradient(145deg, #06a63d, #007c24);
  }

  .seguimiento-modal .seguimiento-content-row > [class*="col-"] {
    padding: 0;
  }

  .seguimiento-modal .seguimiento-map-shell {
    overflow: hidden;
    margin: 0 0 14px;
    padding: 10px;
    border: 1px solid #e0eaf4;
    border-radius: 20px;
    background: #fff;
    box-shadow: 0 8px 22px rgba(31, 67, 110, .08);
  }

  .seguimiento-modal .seguimiento-map-shell::before {
    position: absolute;
    z-index: 6;
    top: 18px;
    left: 22px;
    padding-left: 24px;
    color: #0a2252;
    content: "Mapa de seguimiento";
    font-size: 18px;
    font-weight: 800;
    pointer-events: none;
  }

  .seguimiento-modal .seguimiento-map-shell::after {
    position: absolute;
    z-index: 6;
    top: 20px;
    left: 24px;
    width: 13px;
    height: 13px;
    border-radius: 50% 50% 50% 0;
    background: #0b4e9b;
    content: "";
    pointer-events: none;
    transform: rotate(-45deg);
  }

  .seguimiento-modal .seguimiento-map {
    margin-top: 32px;
    min-height: 250px !important;
    border-radius: 14px;
  }

  .seguimiento-modal .seguimiento-content-panel {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0;
    box-sizing: border-box;
    overflow: hidden;
    padding: 12px;
    border-radius: 18px;
  }

  .seguimiento-modal .seguimiento-content-panel > .row {
    --mdb-gutter-x: 0;
    width: 100%;
    max-width: 100%;
    margin-right: 0;
    margin-left: 0;
    box-sizing: border-box;
  }

  .seguimiento-modal .seguimiento-content-panel > .row > [class*="col-"] {
    min-width: 0;
    padding-right: 0;
    padding-left: 0;
  }

  .seguimiento-modal .seguimiento-switches {
    margin: 0 0 8px;
    padding: 10px 12px;
    border: 1px solid #dce9f7;
    border-radius: 14px;
    background: linear-gradient(110deg, #eff8ff, #fff);
  }

  .seguimiento-modal .scrolling-text {
    color: #0b2a61;
    font-size: 15px;
    font-weight: 700;
  }

  .seguimiento-modal .seguimiento-content-panel > .row:not(.seguimiento-switches) {
    display: grid;
    gap: 8px;
  }

  .seguimiento-modal .seguimiento-content-panel > .row:not(.seguimiento-switches) > [class*="col-"] {
    width: 100%;
    max-width: 100%;
    padding: 0;
  }

  .seguimiento-modal .form-check.form-switch {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;
    min-height: 52px;
    margin: 0;
    padding: 0 10px;
    border-bottom: 1px solid #e5edf5;
    color: #102554;
    font-size: 16px;
  }

  .seguimiento-modal .form-check.form-switch .form-check-input {
    width: 42px;
    height: 24px;
    margin: 0;
    cursor: pointer;
  }

  .seguimiento-modal .seguimiento-meta-card {
    margin: 10px 0 0;
    padding: 12px !important;
    border-color: #d9e7f5;
    border-radius: 16px;
    color: #0b2860;
    font-size: 13px !important;
  }

  .seguimiento-modal .seguimiento-meta-card .row {
    --bs-gutter-x: 12px;
  }

  .seguimiento-modal .seguimiento-meta-card b,
  .seguimiento-modal .seguimiento-meta-card [id] {
    font-size: 13px !important;
  }

  .seguimiento-modal .seguimiento-actions {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px !important;
    justify-content: stretch !important;
    margin-top: 10px;
  }

  .seguimiento-modal .seguimiento-action-button {
    display: inline-flex !important;
    width: 100%;
    min-height: 40px !important;
    padding: 0 8px !important;
    align-items: center;
    justify-content: center;
    border: 0 !important;
    border-radius: 12px !important;
    background: linear-gradient(135deg, #0874d1, #075497) !important;
    box-shadow: 0 5px 13px rgba(7, 84, 151, .18) !important;
    font-size: 12px !important;
  }

  .seguimiento-modal .seguimiento-refresh-icon-button {
    grid-column: 1 / -1;
    justify-self: center;
    width: 48px;
    height: 48px;
    min-height: 48px !important;
    border-radius: 50% !important;
    background: linear-gradient(135deg, #4da92d, #188936) !important;
  }

  .seguimiento-modal .seguimiento-table-card {
    height: 260px !important;
    margin-top: 12px;
    border: 1px solid #d9e7f5;
    border-radius: 14px;
    background: #fff;
  }

  .seguimiento-modal .seguimiento-table-card .tabs {
    display: flex;
    gap: 6px;
    padding: 6px;
    border-bottom: 1px solid #dbe7f2;
  }

  .seguimiento-modal .seguimiento-table-card .tab {
    min-height: 32px;
    padding: 0 14px;
    border: 0;
    border-radius: 8px;
    background: #eff4fa;
    color: #0b2860;
    font-size: 12px;
    font-weight: 700;
  }

  .seguimiento-modal .seguimiento-table-card .tab.active {
    background: #0874ed;
    color: #fff;
  }

  /* Tipografía compacta para aprovechar mejor el alto disponible en móvil. */
  .modal:has(.seguimiento-modal) .modal-title,
  .modal:has(.seguimiento-modal) .base-modal-xxl-header-content {
    font-size: clamp(19px, 5.4vw, 24px);
  }

  .seguimiento-modal .seguimiento-action-link {
    min-height: 38px;
    padding: 0 11px;
    font-size: 11px;
  }

  .seguimiento-modal .seguimiento-topbar .navbar-brand {
    margin-bottom: 8px;
    font-size: 16px;
  }

  .seguimiento-modal .seguimiento-topbar .nav-link {
    min-height: 46px;
    font-size: 13px;
  }

  .seguimiento-modal .seguimiento-kpi-card {
    min-height: 104px;
    padding: 10px;
    font-size: 11px;
  }

  .seguimiento-modal .seguimiento-kpi-card span,
  .seguimiento-modal .seguimiento-kpi-card [id*="contenedorestado"] {
    font-size: clamp(16px, 4.8vw, 21px);
  }

  .seguimiento-modal .seguimiento-map-shell::before {
    font-size: 14px;
  }

  .seguimiento-modal .form-check.form-switch {
    min-height: 42px;
    font-size: 12px;
  }

  .seguimiento-modal .seguimiento-topbar {
    padding: 11px 12px;
    margin-bottom: 10px;
  }

  .seguimiento-modal .seguimiento-map-shell {
    padding: 8px;
    margin-bottom: 10px;
  }

  .seguimiento-modal .seguimiento-map {
    min-height: 210px !important;
  }

  .valitronics-modal-content {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    padding: 0 !important;
    overflow: hidden;
  }

  .valitronics-modal-content .table-container {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/responsive/ResponsiveModalSheets.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,iCAAiC;IACjC,kBAAkB;EACpB;;EAEA;;IAEE,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,6BAA6B;IAC7B,iCAAiC;IACjC,aAAa;IACb,qBAAqB;IACrB;;0CAEsC;IACtC,uBAAuB;IACvB,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,iCAAiC;IACjC,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,sBAAsB;IACtB,6EAA6E;IAC7E,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,iCAAiC;IACjC,6BAA6B;IAC7B,gBAAgB;IAChB,SAAS;IACT,4BAA4B;IAC5B,8CAA8C;EAChD;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,0CAA0C;IAC1C,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,aAAa;EACf;;EAEA;;+DAE6D;EAC7D;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,aAAa;IACb,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;uEACqE;EACrE;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,6BAA6B;IAC7B,oBAAoB;IACpB,sBAAsB;IACtB,wBAAwB;IACxB,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,UAAU;EACZ;;EAEA;wCACsC;EACtC;IACE,2BAA2B;IAC3B,MAAM;IACN,aAAa;IACb,wBAAwB;IACxB,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,8BAA8B;IAC9B,oBAAoB;IACpB,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,aAAa;EACf;;EAEA;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;EACf;;EAEA,wEAAwE;EACxE;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,cAAc;IACd,iCAAiC;IACjC,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,kCAAkC;EACpC;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,qDAAqD;IACrD,6CAA6C;IAC7C,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;EAC/C;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,wBAAwB;IACxB,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,qDAAqD;IACrD,2CAA2C;IAC3C,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,qDAAqD;EACvD;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;EAC/C;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,eAAe;IACf,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,kDAAkD;EACpD;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,gCAAgC;IAChC,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,gDAAgD;IAChD,mBAAmB;IACnB,mCAAmC;IACnC,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;IAC/B,WAAW;IACX,2BAA2B;IAC3B,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,8BAA8B;IAC9B,gEAAgE;IAChE,uDAAuD;IACvD,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,6BAA6B;IAC7B,gEAAgE;EAClE;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA,2EAA2E;EAC3E;;IAEE,mCAAmC;EACrC;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,eAAe;EACjB;;EAEA;;IAEE,mCAAmC;EACrC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iCAAiC;EACnC;AACF","sourcesContent":[".seguimiento-action-link > i {\n  display: none;\n}\n\n@media (max-width: 767px) {\n  .modal {\n    position: fixed !important;\n    inset: 0 !important;\n    padding: 0 !important;\n    width: 100vw !important;\n    max-width: 100vw !important;\n    width: 100dvw !important;\n    max-width: 100dvw !important;\n    box-sizing: border-box !important;\n    overflow-x: hidden;\n  }\n\n  .modal.show,\n  .modal.fade.show {\n    display: flex !important;\n    align-items: flex-end;\n  }\n\n  .modal .modal-dialog {\n    position: absolute !important;\n    inset: auto auto 0 50% !important;\n    display: flex;\n    align-items: flex-end;\n    /* Reactstrap can provide an inline maxWidth (for example 90%).  On a\n       phone every sheet must span the complete viewport, independently of\n       the modal variant that opened it. */\n    width: 100vw !important;\n    min-width: 0 !important;\n    max-width: 100vw !important;\n    width: 100dvw !important;\n    max-width: 100dvw !important;\n    box-sizing: border-box !important;\n    flex: 0 0 100dvw;\n    min-height: 0;\n    height: auto;\n    margin: 0 !important;\n    left: 50% !important;\n    right: auto !important;\n    transform: translate(-50%, var(--responsive-sheet-drag-offset, 0)) !important;\n    transition: transform 180ms ease;\n  }\n\n  .modal .modal-dialog > .modal-content {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100% !important;\n    min-width: 0 !important;\n    max-width: 100% !important;\n    box-sizing: border-box !important;\n    max-height: min(82dvh, 760px);\n    overflow: hidden;\n    border: 0;\n    border-radius: 22px 22px 0 0;\n    box-shadow: 0 -12px 32px rgba(21, 48, 74, .18);\n  }\n\n  .modal.responsive-modal-sheet-expanded .modal-dialog > .modal-content {\n    max-height: 100dvh;\n    min-height: 100dvh;\n    height: 100dvh;\n    border-radius: 0;\n  }\n\n  .modal .modal-dialog > .modal-content > .modal-body {\n    flex: 1 1 auto;\n    min-height: 0;\n    max-height: calc(min(82dvh, 760px) - 72px);\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .modal.responsive-modal-sheet-expanded .modal-dialog > .modal-content > .modal-body {\n    height: auto;\n    max-height: none;\n    min-height: 0;\n  }\n\n  /* Base global de altura: el contenido ocupa toda la hoja y el body es el\n     único elemento que desplaza. Esto evita el espacio vacío inferior que\n     aparece cuando un modal conserva un max-height heredado. */\n  .modal .modal-dialog > .modal-content {\n    height: min(82dvh, 760px);\n  }\n\n  .modal .modal-dialog > .modal-content > .modal-body {\n    height: auto;\n    max-height: none !important;\n  }\n\n  .modal.responsive-modal-sheet-expanded .modal-dialog > .modal-content {\n    height: 100dvh;\n  }\n\n  .responsive-modal-sheet-handle {\n    display: grid;\n    width: 100%;\n    height: 26px;\n    padding: 8px 0 6px;\n    border: 0;\n    background: transparent;\n    cursor: grab;\n    touch-action: none;\n    place-items: center;\n  }\n\n  .responsive-modal-sheet-handle span {\n    width: 42px;\n    height: 4px;\n    border-radius: 999px;\n    background: #aebdcc;\n  }\n\n  .responsive-modal-sheet-handle:active {\n    cursor: grabbing;\n  }\n\n  .responsive-modal-sheet-close {\n    position: absolute;\n    top: 30px;\n    right: 12px;\n    z-index: 3;\n    display: grid;\n    width: 36px;\n    height: 36px;\n    padding: 0;\n    border: 0;\n    border-radius: 50%;\n    background: #edf3f8;\n    color: #38536d;\n    font-size: 28px;\n    line-height: 1;\n    place-items: center;\n  }\n\n  /* La X solo se muestra cuando el bottom sheet está expandido. Mientras\n     permanece colapsado, el cierre se hace con el gesto hacia abajo. */\n  .modal:not(.responsive-modal-sheet-expanded) .modal-header .btn-close,\n  .modal:not(.responsive-modal-sheet-expanded) .responsive-modal-sheet-close {\n    display: none !important;\n  }\n\n  .modal.responsive-modal-sheet-expanded .modal-header .btn-close,\n  .modal.responsive-modal-sheet-expanded .responsive-modal-sheet-close {\n    position: absolute !important;\n    top: 50px !important;\n    right: 16px !important;\n    z-index: 1101 !important;\n    display: grid !important;\n    width: 38px;\n    height: 38px;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    border-radius: 50%;\n    background-color: #edf2f8;\n    background-size: 14px;\n    color: #30445d;\n    opacity: 1;\n  }\n\n  /* Header real y sticky: el body se desplaza, pero esta capa permanece\n     arriba del modal y contiene la X. */\n  .modal .modal-dialog > .modal-content > .modal-header {\n    position: sticky !important;\n    top: 0;\n    z-index: 1100;\n    display: flex !important;\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n    height: auto;\n    min-height: 26px;\n    margin: 0;\n    padding: 8px 0 10px !important;\n    border: 0 !important;\n    background: transparent;\n    overflow: visible;\n    pointer-events: none;\n  }\n\n  .modal .modal-dialog > .modal-content > .modal-header .modal-title {\n    display: block !important;\n    margin: 6px 0 0;\n    padding: 8px 56px 10px 18px;\n    color: #526a83;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 1.25;\n    text-align: left;\n  }\n\n  .modal .modal-dialog > .modal-content > .modal-header .base-modal-xxl-header-content {\n    display: block !important;\n    color: inherit;\n    font: inherit;\n  }\n\n  .modal .modal-dialog > .modal-content > .modal-header .btn-close {\n    position: absolute !important;\n    top: 50px !important;\n    right: 16px !important;\n    pointer-events: auto;\n  }\n\n  .modal .modal-dialog > .modal-content > .modal-header .responsive-modal-sheet-handle {\n    display: grid !important;\n    flex: 0 0 26px;\n    pointer-events: auto;\n    position: relative;\n    z-index: 1102;\n  }\n\n  /* Panel de seguimiento: composición móvil basada en el panel de ruta. */\n  .modal:has(.seguimiento-modal) > .modal-dialog > .modal-content {\n    background: #f7fbff;\n  }\n\n  .modal:has(.seguimiento-modal) .modal-header {\n    padding: 12px 22px 8px;\n    border: 0;\n  }\n\n  .modal:has(.seguimiento-modal) .modal-title,\n  .modal:has(.seguimiento-modal) .base-modal-xxl-header-content {\n    color: #071b49;\n    font-size: clamp(25px, 7vw, 34px);\n    font-weight: 800;\n    line-height: 1.1;\n  }\n\n  .modal:has(.seguimiento-modal) .modal-body {\n    padding: 8px 8px 24px;\n  }\n\n  .seguimiento-modal {\n    padding: 0 !important;\n    background: transparent !important;\n  }\n\n  .seguimiento-modal > .row {\n    --mdb-gutter-x: 0;\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .seguimiento-modal .seguimiento-links-row {\n    margin: 0 0 14px !important;\n  }\n\n  .seguimiento-modal .seguimiento-links-row > div {\n    overflow-x: auto !important;\n    padding: 2px 0 8px;\n    scrollbar-width: none;\n  }\n\n  .seguimiento-modal .seguimiento-links-row > div::-webkit-scrollbar {\n    display: none;\n  }\n\n  .seguimiento-modal .seguimiento-links {\n    width: max-content;\n    gap: 9px;\n  }\n\n  .seguimiento-modal .seguimiento-action-link {\n    display: inline-flex;\n    align-items: center;\n    min-height: 44px;\n    padding: 0 15px;\n    border: 1px solid #dce7f4;\n    border-radius: 15px;\n    background: #f3f7fc;\n    color: #102554;\n    font-size: 14px;\n    font-weight: 700;\n    text-decoration: none;\n    white-space: nowrap;\n  }\n\n  .seguimiento-modal .seguimiento-action-link > i {\n    display: inline-block;\n    margin-right: 8px;\n    font-size: 21px;\n    line-height: 1;\n  }\n\n  .seguimiento-modal .seguimiento-action-link:first-child {\n    border-color: #1479ff;\n    background: linear-gradient(135deg, #0078ff, #1168e9);\n    box-shadow: 0 8px 18px rgba(0, 103, 241, .22);\n    color: #fff;\n  }\n\n  .seguimiento-modal .seguimiento-link-separator {\n    display: none;\n  }\n\n  .seguimiento-modal .seguimiento-topbar {\n    margin-bottom: 14px;\n    padding: 14px 16px;\n    border: 1px solid #e0eaf4;\n    border-radius: 20px;\n    background: #fff;\n    box-shadow: 0 8px 22px rgba(31, 67, 110, .08);\n  }\n\n  .seguimiento-modal .seguimiento-topbar .container-fluid {\n    display: block;\n    padding: 0;\n  }\n\n  .seguimiento-modal .seguimiento-topbar .navbar-brand {\n    display: block;\n    margin: 0 0 12px;\n    color: #081b49 !important;\n    font-size: 21px;\n    font-weight: 800;\n  }\n\n  .seguimiento-modal .seguimiento-topbar .navbar-toggler {\n    display: none;\n  }\n\n  .seguimiento-modal .seguimiento-topbar .navbar-collapse,\n  .seguimiento-modal .seguimiento-topbar .navbar-nav {\n    display: grid !important;\n    width: 100%;\n    gap: 9px;\n  }\n\n  .seguimiento-modal .seguimiento-topbar .nav-link {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-height: 58px;\n    padding: 0 16px;\n    border-radius: 14px;\n    background: #edf4fb;\n    color: #102b5c !important;\n    font-size: 17px;\n    font-weight: 600;\n  }\n\n  .seguimiento-modal .seguimiento-kpis {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 8px;\n    margin: 0 0 14px;\n  }\n\n  .seguimiento-modal .seguimiento-kpis > [class*=\"col-\"] {\n    width: auto;\n    max-width: none;\n    padding: 0;\n  }\n\n  .seguimiento-modal .seguimiento-kpi-card {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    min-height: 132px;\n    padding: 14px 12px;\n    border: 0;\n    border-radius: 17px;\n    background: linear-gradient(145deg, #073c7c, #001f48);\n    box-shadow: 0 8px 18px rgba(4, 38, 82, .18);\n    color: #fff;\n    font-family: inherit;\n    font-size: 13px;\n    text-align: left;\n  }\n\n  .seguimiento-modal .seguimiento-kpi-card span,\n  .seguimiento-modal .seguimiento-kpi-card [id*=\"contenedorestado\"] {\n    margin-top: 6px;\n    font-size: clamp(20px, 6vw, 29px);\n    font-weight: 800;\n    line-height: 1;\n  }\n\n  .seguimiento-modal [id*=\"contenedorestadodiv\"] {\n    background: linear-gradient(145deg, #06a63d, #007c24);\n  }\n\n  .seguimiento-modal .seguimiento-content-row > [class*=\"col-\"] {\n    padding: 0;\n  }\n\n  .seguimiento-modal .seguimiento-map-shell {\n    overflow: hidden;\n    margin: 0 0 14px;\n    padding: 10px;\n    border: 1px solid #e0eaf4;\n    border-radius: 20px;\n    background: #fff;\n    box-shadow: 0 8px 22px rgba(31, 67, 110, .08);\n  }\n\n  .seguimiento-modal .seguimiento-map-shell::before {\n    position: absolute;\n    z-index: 6;\n    top: 18px;\n    left: 22px;\n    padding-left: 24px;\n    color: #0a2252;\n    content: \"Mapa de seguimiento\";\n    font-size: 18px;\n    font-weight: 800;\n    pointer-events: none;\n  }\n\n  .seguimiento-modal .seguimiento-map-shell::after {\n    position: absolute;\n    z-index: 6;\n    top: 20px;\n    left: 24px;\n    width: 13px;\n    height: 13px;\n    border-radius: 50% 50% 50% 0;\n    background: #0b4e9b;\n    content: \"\";\n    pointer-events: none;\n    transform: rotate(-45deg);\n  }\n\n  .seguimiento-modal .seguimiento-map {\n    margin-top: 32px;\n    min-height: 250px !important;\n    border-radius: 14px;\n  }\n\n  .seguimiento-modal .seguimiento-content-panel {\n    width: 100% !important;\n    max-width: 100% !important;\n    min-width: 0;\n    box-sizing: border-box;\n    overflow: hidden;\n    padding: 12px;\n    border-radius: 18px;\n  }\n\n  .seguimiento-modal .seguimiento-content-panel > .row {\n    --mdb-gutter-x: 0;\n    width: 100%;\n    max-width: 100%;\n    margin-right: 0;\n    margin-left: 0;\n    box-sizing: border-box;\n  }\n\n  .seguimiento-modal .seguimiento-content-panel > .row > [class*=\"col-\"] {\n    min-width: 0;\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .seguimiento-modal .seguimiento-switches {\n    margin: 0 0 8px;\n    padding: 10px 12px;\n    border: 1px solid #dce9f7;\n    border-radius: 14px;\n    background: linear-gradient(110deg, #eff8ff, #fff);\n  }\n\n  .seguimiento-modal .scrolling-text {\n    color: #0b2a61;\n    font-size: 15px;\n    font-weight: 700;\n  }\n\n  .seguimiento-modal .seguimiento-content-panel > .row:not(.seguimiento-switches) {\n    display: grid;\n    gap: 8px;\n  }\n\n  .seguimiento-modal .seguimiento-content-panel > .row:not(.seguimiento-switches) > [class*=\"col-\"] {\n    width: 100%;\n    max-width: 100%;\n    padding: 0;\n  }\n\n  .seguimiento-modal .form-check.form-switch {\n    display: flex;\n    flex-direction: row-reverse;\n    align-items: center;\n    justify-content: space-between;\n    min-height: 52px;\n    margin: 0;\n    padding: 0 10px;\n    border-bottom: 1px solid #e5edf5;\n    color: #102554;\n    font-size: 16px;\n  }\n\n  .seguimiento-modal .form-check.form-switch .form-check-input {\n    width: 42px;\n    height: 24px;\n    margin: 0;\n    cursor: pointer;\n  }\n\n  .seguimiento-modal .seguimiento-meta-card {\n    margin: 10px 0 0;\n    padding: 12px !important;\n    border-color: #d9e7f5;\n    border-radius: 16px;\n    color: #0b2860;\n    font-size: 13px !important;\n  }\n\n  .seguimiento-modal .seguimiento-meta-card .row {\n    --bs-gutter-x: 12px;\n  }\n\n  .seguimiento-modal .seguimiento-meta-card b,\n  .seguimiento-modal .seguimiento-meta-card [id] {\n    font-size: 13px !important;\n  }\n\n  .seguimiento-modal .seguimiento-actions {\n    display: grid !important;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 8px !important;\n    justify-content: stretch !important;\n    margin-top: 10px;\n  }\n\n  .seguimiento-modal .seguimiento-action-button {\n    display: inline-flex !important;\n    width: 100%;\n    min-height: 40px !important;\n    padding: 0 8px !important;\n    align-items: center;\n    justify-content: center;\n    border: 0 !important;\n    border-radius: 12px !important;\n    background: linear-gradient(135deg, #0874d1, #075497) !important;\n    box-shadow: 0 5px 13px rgba(7, 84, 151, .18) !important;\n    font-size: 12px !important;\n  }\n\n  .seguimiento-modal .seguimiento-refresh-icon-button {\n    grid-column: 1 / -1;\n    justify-self: center;\n    width: 48px;\n    height: 48px;\n    min-height: 48px !important;\n    border-radius: 50% !important;\n    background: linear-gradient(135deg, #4da92d, #188936) !important;\n  }\n\n  .seguimiento-modal .seguimiento-table-card {\n    height: 260px !important;\n    margin-top: 12px;\n    border: 1px solid #d9e7f5;\n    border-radius: 14px;\n    background: #fff;\n  }\n\n  .seguimiento-modal .seguimiento-table-card .tabs {\n    display: flex;\n    gap: 6px;\n    padding: 6px;\n    border-bottom: 1px solid #dbe7f2;\n  }\n\n  .seguimiento-modal .seguimiento-table-card .tab {\n    min-height: 32px;\n    padding: 0 14px;\n    border: 0;\n    border-radius: 8px;\n    background: #eff4fa;\n    color: #0b2860;\n    font-size: 12px;\n    font-weight: 700;\n  }\n\n  .seguimiento-modal .seguimiento-table-card .tab.active {\n    background: #0874ed;\n    color: #fff;\n  }\n\n  /* Tipografía compacta para aprovechar mejor el alto disponible en móvil. */\n  .modal:has(.seguimiento-modal) .modal-title,\n  .modal:has(.seguimiento-modal) .base-modal-xxl-header-content {\n    font-size: clamp(19px, 5.4vw, 24px);\n  }\n\n  .seguimiento-modal .seguimiento-action-link {\n    min-height: 38px;\n    padding: 0 11px;\n    font-size: 11px;\n  }\n\n  .seguimiento-modal .seguimiento-topbar .navbar-brand {\n    margin-bottom: 8px;\n    font-size: 16px;\n  }\n\n  .seguimiento-modal .seguimiento-topbar .nav-link {\n    min-height: 46px;\n    font-size: 13px;\n  }\n\n  .seguimiento-modal .seguimiento-kpi-card {\n    min-height: 104px;\n    padding: 10px;\n    font-size: 11px;\n  }\n\n  .seguimiento-modal .seguimiento-kpi-card span,\n  .seguimiento-modal .seguimiento-kpi-card [id*=\"contenedorestado\"] {\n    font-size: clamp(16px, 4.8vw, 21px);\n  }\n\n  .seguimiento-modal .seguimiento-map-shell::before {\n    font-size: 14px;\n  }\n\n  .seguimiento-modal .form-check.form-switch {\n    min-height: 42px;\n    font-size: 12px;\n  }\n\n  .seguimiento-modal .seguimiento-topbar {\n    padding: 11px 12px;\n    margin-bottom: 10px;\n  }\n\n  .seguimiento-modal .seguimiento-map-shell {\n    padding: 8px;\n    margin-bottom: 10px;\n  }\n\n  .seguimiento-modal .seguimiento-map {\n    min-height: 210px !important;\n  }\n\n  .valitronics-modal-content {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n    padding: 0 !important;\n    overflow: hidden;\n  }\n\n  .valitronics-modal-content .table-container {\n    width: 100%;\n    max-width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
